export default __webpack_public_path__ + "media/images/logo_transparent.svg";